const embedElement = 'root';

const testPandaPayPublicKey = 'pk_test_99wLIEGW-t4LifFKEKUeqQ';
const productionPandaPayPublicKey = 'pk_live_AQsY1s0Pz4t4FL-cZYuU7Q';
const testOrgHunterPublicKey = 'pk_test_kDZAGD17wmYYuIowhcGTY7DE';
const productionOrgHunterPublicKey = 'pk_live_nKFDu2Q2M5XwRBvQeArgOaMg';
const testGoogleAnalytics = 'UA-67279182-3';
const testEventsGoogleAnalytics = 'UA-67279182-12';
const productionGoogleAnalytics = 'UA-67279182-4';
const productionEventsGoogleAnalytics = 'UA-67279182-13';
const testGoogleMaps = 'AIzaSyBHo2kvbSbUmx389ZjLhwRj3ge5BbO0Jsk';
const productionGoogleMaps = 'AIzaSyCLy3W02ktjqp0_RCCeGNvWBRJM-QcvyZM';

const configLocal = {
    API_BASE_URL: 'https://qa-api.actionbutton.co/api/',
    CDN_URL: 'https://qa-api.actionbutton.co/api/logos/get/',
    EMBED_ELEMENT: embedElement,
    GOOGLE_MAPS_PUBLIC_KEY: testGoogleMaps,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: testEventsGoogleAnalytics,
    GOOGLE_ANALYTICS_USER_ID: testGoogleAnalytics,
    PANDA_PAY_PUBLIC_KEY: testPandaPayPublicKey,
    ORG_HUNTER_PUBLIC_KEY: testOrgHunterPublicKey,
    SCRIPT_URL: 'https://localhost:3000/',
    SENTRY_ENV: 'localhost',
    DEFAULT_IMAGES_URL: `https://images.actionbutton.co/`
};

const configQa = {
    API_BASE_URL: 'https://qa-api.actionbutton.co/api/',
    CDN_URL: 'https://qa-api.actionbutton.co/api/logos/get/',
    EMBED_ELEMENT: embedElement,
    GOOGLE_MAPS_PUBLIC_KEY: testGoogleMaps,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: testEventsGoogleAnalytics,
    GOOGLE_ANALYTICS_USER_ID: testGoogleAnalytics,
    PANDA_PAY_PUBLIC_KEY: testPandaPayPublicKey,
    ORG_HUNTER_PUBLIC_KEY: testOrgHunterPublicKey,
    SCRIPT_URL: 'https://s3.amazonaws.com/embed.actionbutton.co/qa/widget/',
    SENTRY_ENV: 'qa',
    PAYMENT_PAGE_URL: 'https://qa-payments.actionbutton.co/',
    DEFAULT_IMAGES_URL: `https://images.actionbutton.co/`
};

const configStage = {
    API_BASE_URL: 'https://stage-api.actionbutton.co/api/',
    CDN_URL: 'https://stage-api.actionbutton.co/api/logos/get/',
    EMBED_ELEMENT: embedElement,
    GOOGLE_MAPS_PUBLIC_KEY: testGoogleMaps,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: testEventsGoogleAnalytics,
    GOOGLE_ANALYTICS_USER_ID: testGoogleAnalytics,
    PANDA_PAY_PUBLIC_KEY: testPandaPayPublicKey,
    ORG_HUNTER_PUBLIC_KEY: testOrgHunterPublicKey,
    SCRIPT_URL: 'https://s3.amazonaws.com/embed.actionbutton.co/stage/widget/',
    SENTRY_ENV: 'staging',
    PAYMENT_PAGE_URL: 'https://stage-payments.actionbutton.co',
    DEFAULT_IMAGES_URL: `https://images.actionbutton.co/`
};

const configProduction = {
    API_BASE_URL: 'https://api.actionbutton.co/api/',
    CDN_URL: 'https://static.actionbutton.co/',
    EMBED_ELEMENT: embedElement,
    GOOGLE_MAPS_PUBLIC_KEY: productionGoogleMaps,
    GOOGLE_ANALYTICS_EVENTS_USER_ID: productionEventsGoogleAnalytics,
    GOOGLE_ANALYTICS_USER_ID: productionGoogleAnalytics,
    PANDA_PAY_PUBLIC_KEY: productionPandaPayPublicKey,
    ORG_HUNTER_PUBLIC_KEY: productionOrgHunterPublicKey,
    SCRIPT_URL: 'https://embed.actionbutton.co/widget/',
    SENTRY_ENV: 'production',
    PAYMENT_PAGE_URL: 'https://payments.actionbutton.co',
    DEFAULT_IMAGES_URL: `https://images.actionbutton.co/`
};

const getConfig = () => {
    switch (process.env.REACT_APP_ENV || process.env.REACT_STATIC_ENV) {
        case 'node':
            return configLocal;
        case 'local':
            return configLocal;
        case 'qa':
            return configQa;
        case 'stage':
            return configStage;
        case 'production':
            return configProduction;
        default:
            throw new Error('Environment not valid!');
    }
};

const config = getConfig();

export default config;
